function initBundleX4() {
  const addButton = document.getElementById('bundle-x4-add-to-cart');
  const feedback = document.getElementById('bundle-x4-feedback');
  const selects = document.querySelectorAll('.bundle-x4__slot-select');

  if (!addButton || addButton.dataset.bundleInitialized) {
    return;
  }
  addButton.dataset.bundleInitialized = 'true';

  selects.forEach(function (select) {
    select.addEventListener('change', function () {
      const slot = select.closest('.bundle-x4__slot');
      const img = slot ? slot.querySelector('.bundle-x4__slot-image img') : null;
      const selectedOption = select.options[select.selectedIndex];
      if (img && selectedOption.dataset.image) {
        img.src = selectedOption.dataset.image;
        img.alt = selectedOption.dataset.title || '';
      }
    });
  });

  const toggleButton = document.getElementById('bundle-x4-personalize-toggle');
  const slotsBlock = document.getElementById('bundle-x4-slots');

  if (toggleButton && slotsBlock && !toggleButton.dataset.toggleInitialized) {
    toggleButton.dataset.toggleInitialized = 'true';
    toggleButton.addEventListener('click', function () {
      const isHidden = slotsBlock.hasAttribute('hidden');
      if (isHidden) {
        slotsBlock.removeAttribute('hidden');
        toggleButton.textContent = 'Masquer la personnalisation';
      } else {
        slotsBlock.setAttribute('hidden', '');
        toggleButton.textContent = 'Personnaliser les couleurs';
      }
    });
  }

  selects.forEach(function (select) {
    const index = select.dataset.slotIndex;
    const circle = document.querySelector('.bundle-x4__circle[data-slot-index="' + index + '"]');
    if (circle && !select.dataset.circleSyncInitialized) {
      select.dataset.circleSyncInitialized = 'true';
      select.addEventListener('change', function () {
        const selectedOption = select.options[select.selectedIndex];
        const circleImg = circle.querySelector('img');
        if (circleImg && selectedOption.dataset.image) {
          circleImg.src = selectedOption.dataset.image;
          circleImg.alt = selectedOption.dataset.title || '';
        }
      });
    }
  });

  /**
   * Reprend l'animation native du theme : une image par bracelet vole vers
   * l'icone du panier. Le composant <fly-to-cart> et ses styles sont deja
   * charges par le theme (scripts.liquid + bloc add-to-cart).
   */
  async function flyBundleToCart() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const cartIcon = document.querySelector('.header-actions__cart-icon');
    if (!cartIcon) return;

    // Source = le bouton, comme dans product-form.js. Les vignettes ne sont pas
    // toujours visibles (bloc replie sur la fiche produit), le bouton si.
    const images = Array.from(selects)
      .map(function (select) {
        const option = select.options[select.selectedIndex];
        return option && option.dataset.image ? option.dataset.image : null;
      })
      .filter(Boolean);

    if (!images.length) return;

    // Sans cette attente, l'upgrade du custom element reinitialiserait
    // les proprietes source/destination qu'on vient de poser.
    await customElements.whenDefined('fly-to-cart');

    images.forEach(function (image, i) {
      setTimeout(function () {
        const flyer = document.createElement('fly-to-cart');
        flyer.classList.add('fly-to-cart--main');
        flyer.style.setProperty('background-image', 'url(' + image + ')');
        flyer.style.setProperty('--start-opacity', '0');
        flyer.source = addButton;
        flyer.destination = cartIcon;
        document.body.appendChild(flyer);
      }, i * 90);
    });
  }

  const DEFAULT_LABEL = addButton.textContent.trim() || 'Ajouter mon pack au panier';

  addButton.addEventListener('click', async function () {
    const items = Array.from(selects).map(function (select) {
      return { id: parseInt(select.value, 10), quantity: 1 };
    });

    if (!items.length || items.some((item) => Number.isNaN(item.id))) {
      return;
    }

    // Declenchee des le clic, comme l'animation native, pour la reactivite.
    flyBundleToCart();

    addButton.disabled = true;
    addButton.textContent = 'Ajout en cours...';

    // On demande les sections a re-rendre DANS la requete d'ajout.
    // Sans ca, le theme doit refaire une requete complete pour rafraichir le panier.
    const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
      .map((el) => el.dataset.sectionId)
      .filter(Boolean);

    const { CartLinesUpdateEvent } = await import('@shopify/events');
    const deferredPromise = CartLinesUpdateEvent.createPromise();

    // Cible = ancetre de cart-items-component (il ignore l'evenement s'il en est la cible).
    const target = document.querySelector('cart-drawer-component') || document.body;

    target.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: items.map(function (item) {
          return { merchandiseId: String(item.id), quantity: item.quantity };
        }),
        promise: deferredPromise.promise,
      })
    );

    try {
      const response = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: items,
          sections: sectionIds.join(','),
          sections_url: window.location.pathname,
        }),
      });

      const data = await response.json();

      if (data.status) {
        throw new Error(data.message || "Erreur lors de l'ajout");
      }

      const ajaxCart = await fetch(Theme.routes.cart_url + '.js').then((r) => r.json());

      // On fournit cart + sections : le theme fait un morph cible du DOM,
      // sans refetch ni reconstruction complete du drawer.
      deferredPromise.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
        detail: {
          items: ajaxCart.items,
          source: 'bundle-x4',
          sourceId: 'bundle-x4',
          itemCount: items.length,
          sections: data.sections,
          didError: false,
        },
      });

      addButton.textContent = DEFAULT_LABEL;
      addButton.disabled = false;

      if (feedback) {
        feedback.textContent = '✓ Pack ajouté au panier !';
        feedback.hidden = false;
        setTimeout(function () {
          feedback.hidden = true;
        }, 4000);
      }
    } catch (error) {
      console.error('Erreur ajout panier:', error);
      // Sans reject, la promesse reste en attente et le drawer garde son etat de chargement.
      deferredPromise.reject(error);

      addButton.textContent = DEFAULT_LABEL;
      addButton.disabled = false;

      if (feedback) {
        feedback.textContent = 'Erreur : ' + error.message;
        feedback.hidden = false;
      }
    }
  });
}


/**
 * Option "1 bracelet" du tiroir solo de la carte d'offre.
 * Meme contrat que le pack : evenement AVANT la requete, resolution avec
 * cart + sections pour que le theme morphe le drawer sans refetch.
 */
function initBundleSolo() {
  const soloButton = document.getElementById('bundle-x4-solo-add');
  if (!soloButton || soloButton.dataset.soloInitialized) {
    return;
  }
  soloButton.dataset.soloInitialized = 'true';

  const DEFAULT_LABEL = soloButton.textContent.trim();
  const feedback = document.getElementById('bundle-x4-feedback');

  function flySoloToCart(input) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const cartIcon = document.querySelector('.header-actions__cart-icon');
    const image = input.dataset.image;
    if (!cartIcon || !image) return;

    customElements.whenDefined('fly-to-cart').then(function () {
      const flyer = document.createElement('fly-to-cart');
      flyer.classList.add('fly-to-cart--main');
      flyer.style.setProperty('background-image', 'url(' + image + ')');
      flyer.style.setProperty('--start-opacity', '0');
      flyer.source = soloButton;
      flyer.destination = cartIcon;
      document.body.appendChild(flyer);
    });
  }

  soloButton.addEventListener('click', async function () {
    const checked = document.querySelector('input[name="bx4-solo-color"]:checked');
    if (!checked) return;

    const variantId = parseInt(checked.value, 10);
    if (Number.isNaN(variantId)) return;

    soloButton.disabled = true;
    soloButton.textContent = 'Ajout en cours...';

    flySoloToCart(checked);

    const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
      .map((el) => el.dataset.sectionId)
      .filter(Boolean);

    const { CartLinesUpdateEvent } = await import('@shopify/events');
    const deferredPromise = CartLinesUpdateEvent.createPromise();
    const target = document.querySelector('cart-drawer-component') || document.body;

    target.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: String(variantId), quantity: 1 }],
        promise: deferredPromise.promise,
      })
    );

    try {
      const response = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: sectionIds.join(','),
          sections_url: window.location.pathname,
        }),
      });

      const data = await response.json();

      if (data.status) {
        throw new Error(data.message || "Erreur lors de l'ajout");
      }

      const ajaxCart = await fetch(Theme.routes.cart_url + '.js').then((r) => r.json());

      deferredPromise.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
        detail: {
          items: ajaxCart.items,
          source: 'bundle-solo',
          sourceId: 'bundle-solo',
          itemCount: 1,
          sections: data.sections,
          didError: false,
        },
      });

      soloButton.textContent = DEFAULT_LABEL;
      soloButton.disabled = false;

      if (feedback) {
        feedback.textContent = '\u2713 Bracelet ajout\u00e9 au panier !';
        feedback.hidden = false;
        setTimeout(function () {
          feedback.hidden = true;
        }, 4000);
      }
    } catch (error) {
      console.error('Erreur ajout panier (solo):', error);
      deferredPromise.reject(error);
      soloButton.textContent = DEFAULT_LABEL;
      soloButton.disabled = false;
    }
  });
}

// Le script est charge en `defer` : le DOM est deja parse a l'execution.
initBundleX4();
initBundleSolo();
document.addEventListener('shopify:section:load', initBundleX4);
document.addEventListener('shopify:section:load', initBundleSolo);
